import { action } from 'mobx'

import BaseListStore from 'stores/base/BaseListStore'
import ActionStore from 'stores/action/ActionStore'

import Session, { ISessionCreatePayload } from './Session'

class SessionStore extends BaseListStore<Session, ISessionCreatePayload> {
  constructor() {
    super(Session, { idbTableName: 'sessions' })
  }

  /**
   * Get a session for a given script. Creates a new one if one does not already exist
   */
  @action
  findOrCreate = ({ scriptId }: Omit<ISessionCreatePayload, 'id'>): Session => {
    const sessionWithThisScript = Object.values(this.values).find(
      s => s.scriptId === scriptId
    )
    return (
      sessionWithThisScript ||
      this.add({
        type: 'script',
        scriptId,
        lastSavedHash: null,
      })
    )
  }

  @action
  remove = (sessionId: string): Session => {
    const removedSession = super.remove(sessionId)

    Object.values(ActionStore.values).forEach(action => {
      if (action.sessionId === sessionId) {
        ActionStore.remove(action.id)
      }
    })

    return removedSession
  }
}

export default new SessionStore()
